import { render, staticRenderFns } from "./sales-slip-nouhin.vue?vue&type=template&id=133a36fc&scoped=true&"
import script from "./sales-slip-nouhin.vue?vue&type=script&lang=js&"
export * from "./sales-slip-nouhin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "133a36fc",
  null
  
)

export default component.exports